import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Jumbotron,
  Container,
  Col,
  Row,
  Form,
  Button,
  Modal,
  Spinner,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  NavLink,
} from 'reactstrap';
import { withApollo } from 'react-apollo';
import { useQuery, useMutation } from '@apollo/react-hooks';
import TemplateName from './templateName';
import TemplateDatePickers from '../templates-manager/template-components/TemplateDatePickers';
import { CREATE_TEMPLATES } from '../../mutation/mutation';
import './templates.css';
import templatesFonts from '../../fonts/templates-fonts';
import { GET_TEMPLATE_CATEGORIES } from '../../query/query';
import Tags from '../templates-manager/tags/tags';
import MultiImageUpload from '../sav-lovebox/components/MultiImageUpload';

const TemplatesBatchPage = () => {
  const [backgroundImages, setBackgroundImages] = useState([]);
  const [templateName, updateTemplateName] = useState('');
  const [modal, toggleModal] = useState(false);
  const [modalSuccess, toggleModalSuccess] = useState(false);
  const [modalError, toggleModalError] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [subCategoriesList, setSubCategoriesList] = useState([]);

  const {
    data: { savGetTemplateCategories: templateCategories = [] } = {},
  } = useQuery(
    GET_TEMPLATE_CATEGORIES,
    { fetchPolicy: 'cache-and-network' },
  );
  const [createTemplates] = useMutation(CREATE_TEMPLATES);
  useEffect(() => {
    if (!templateCategories.length) return;
    setSubCategoriesList(
      [].concat.apply([], [...templateCategories.map(({ subCategories: s }) => s)]),
    );
  }, [templateCategories]);

  useEffect(() => {
    setCanSubmit(backgroundImages.length > 0);
  }, [backgroundImages]);

  const handleCreateTemplates = async () => {
    toggleModal(true);
    const templates = [];
    for (let index = 0; index < backgroundImages.length; index += 1) {
      const template = {
        background: backgroundImages[index],
        backgroundCover: undefined,
        name: `${templateName} - ${index}`,
        subCategories: subCategories.map(({ _id: categoriesId }) => categoriesId),
        texts: [],
        thumbnailFr: backgroundImages[index],
        thumbnailEn: backgroundImages[index],
        status,
        releaseDate: (status === 'PENDING' && releaseDate) ? moment(releaseDate).format('YYYY-MM-DD') : null,
      };
      templates.push(template);
    }
    createTemplates({ variables: { templates } })
      .then(() => { toggleModalSuccess(true); })
      .catch((err) => { toggleModalError(err.message); });
  };

  const closeModalError = () => {
    toggleModal(false);
    toggleModalError(false);
  };

  const [releaseDate, setReleaseDate] = useState();

  const [status, setStatus] = useState('PENDING');

  return (
    <Jumbotron className="templates">
      {templatesFonts.map(({ fontFamily, name: fontName }) => (
        <div
          key={fontFamily}
          style={{
            fontFamily, position: 'absolute', top: '-100%', opacity: 0,
          }}
        >
          {fontName}
        </div>
      ))}
      <h3 className="display-4">
        Create Templates by Batch
      </h3>
      <p>
        Upload a list of background files.
        It will create templates with that list of backgrounds.
      </p>
      <p>Templates names will be the name you define below followed by an index number.</p>
      <p>All created templates will have the same categories, status and release date.</p>
      <p>
        Use [FR] or [EN] prefix in the name field if the uploaded
        backgrounds contain language specific content.
      </p>
      <NavLink href="/templates/create">Or follow this link to create templates one by one</NavLink>
      <Container>
        <Form>
          <TemplateName
            name={templateName}
            updateTemplateName={updateTemplateName}
          />
          <MultiImageUpload
            setImages={setBackgroundImages}
          />
          <Row>
            <Col className="col_form">
              <Tags
                subCategories={subCategories}
                subCategoriesList={subCategoriesList}
                updateTemplateSubCategories={setSubCategories}
              />
              <Row style={{ alignItems: 'center', marginTop: 20 }}>
                <ButtonGroup style={{ marginLeft: 10 }}>
                  <Button
                    color={status === 'PENDING' ? 'primary' : 'secondary'}
                    onClick={() => setStatus('PENDING')}
                  >
                    PUBLISH LATER
                  </Button>
                  <Button
                    color={status === 'ACCEPTED' ? 'primary' : 'secondary'}
                    onClick={() => setStatus('ACCEPTED')}
                  >
                    PUBLISH NOW
                  </Button>
                  { status === 'PENDING' && (
                    <div>
                      <TemplateDatePickers
                        status="PENDING"
                        releaseDate={releaseDate}
                        setTemplateReleaseDate={setReleaseDate}
                      />
                    </div>
                  )}
                </ButtonGroup>
              </Row>
            </Col>
          </Row>
          <Button
            color="success"
            disabled={!canSubmit}
            onClick={handleCreateTemplates}
            style={styles.submitButton}
          >
            Create Templates
          </Button>
        </Form>
      </Container>
      <Modal isOpen={modal} toggle={toggleModal} className="modalTemplate">
        {modalSuccess && (
          <ModalBody>
            Template Created
            <ModalFooter>
              {/* eslint-disable-next-line no-undef */}
              <Button color="success" onClick={() => window.location.reload()}>Ok</Button>
            </ModalFooter>
          </ModalBody>
        )}
        {modalError && (
          <ModalBody>
            Error creating template :
            {' '}
            {modalError}
            <ModalFooter>
              <Button color="danger" onClick={closeModalError}>Ok</Button>
            </ModalFooter>
          </ModalBody>
        )}
        {!modalSuccess && !modalError && (
          <Spinner color="primary" />
        )}
      </Modal>
    </Jumbotron>
  );
};

const styles = {
  loading: {
    fontSize: 18,
    width: '100%',
    textAlign: 'center',
    marginTop: 30,
  },
  submitButton: {
    marginTop: 20,
  },
};

export default withApollo(TemplatesBatchPage);



// WEBPACK FOOTER //
// ./src/components/templates/batch_templates.js